import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import categoriasConEmoji from "../utils/categoriasConEmoji";
import Layout from "../layout/Layout";

const categorias = [
    "Comida",
    "Renta",
    "Gas",
    "Luz",
    "Agua",
    "Mantenimiento",
    "Plataformas",
    "Transporte",
    "Otros"
];

export default function AddGasto() {
    const [gastos, setGastos] = useState([]);

    const formik = useFormik({
        initialValues: {
            nombre: "",
            monto: "",
            categoria: "Otros",
            fecha: ""
        },
        validationSchema: Yup.object({
            nombre: Yup.string().required("Nombre obligatorio"),
            monto: Yup.number()
                .min(1, "Debe ser mayor a 0")
                .required("Monto requerido"),
            categoria: Yup.string().required("Selecciona una categoría"),
            fecha: Yup.date().required("Fecha obligatoria")
        }),
        onSubmit: (values, { resetForm }) => {
            const quincena = new Date(values.fecha).getDate() <= 15 ? "1" : "2";
            const gasto = { ...values, quincena };
            setGastos([...gastos, gasto]);
            resetForm();
        }
    });

    const enviarGastos = async () => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_DOMINIO}/wp-json/finanzas/v1/gastos`,
                { gastos },
                { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
            );

            if (res.data.success) {
                alert("Gastos registrados 🧾");
                setGastos([]);
            } else {
                alert("Error: " + res.data.message);
            }
        } catch (error) {
            console.error(error);
            alert("Error al enviar gastos");
        }
    };

    return (
        <Layout>
            <div className="container text-center">
                <div className="row">
                    <div className="col-12 col-sm-6">

                        <div className="div-card">
                            <h4>Agregar gastos</h4>
                            <form onSubmit={formik.handleSubmit}>
                                <div className="mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="nombre"
                                        placeholder="Nombre del gasto"
                                        value={formik.values.nombre}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.nombre && formik.errors.nombre && (
                                        <p style={{ color: "red" }}>{formik.errors.nombre}</p>
                                    )}
                                </div>
                                <div className="mb-3">

                                    <input
                                        type="number"
                                        name="monto"
                                        className="form-control"
                                        placeholder="Monto"
                                        value={formik.values.monto}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.monto && formik.errors.monto && (
                                        <p style={{ color: "red" }}>{formik.errors.monto}</p>
                                    )}
                                </div>
                                <div className="mb-3">


                                    <select
                                        name="categoria"
                                        className="form-control"
                                        value={formik.values.categoria}
                                        onChange={formik.handleChange}
                                    >
                                        {categorias.map((cat) => (
                                            <option key={cat} value={cat}>
                                                {categoriasConEmoji[cat] || ""} {cat}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="mb-3">

                                    <input
                                        type="date"
                                        name="fecha"
                                        className="form-control"
                                        value={formik.values.fecha}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.fecha && formik.errors.fecha && (
                                        <p style={{ color: "red" }}>{formik.errors.fecha}</p>
                                    )}
                                </div>
                                <button className="btn btn-warning" type="submit">Agregar a la lista</button>
                            </form>

                            {gastos.length > 0 && (
                                <div>
                                    <h3>Gastos pendientes por guardar:</h3>
                                    <ul>
                                        {gastos.map((g, i) => (
                                            <li key={i}>
                                                {categoriasConEmoji[g.categoria] || ""} {g.nombre} – ${g.monto} – {g.fecha} (Q{g.quincena})
                                            </li>
                                        ))}
                                    </ul>
                                    <button onClick={enviarGastos}>Guardar todos</button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

        </Layout>
    );
}
